import styles from './UserAvatar.module.css';

interface Props {
  url: string | null | undefined;
  firstName: string | null | undefined;
  className?: string;
  initialClassName?: string;
  testId?: string;
}

function initialOf(name: string | null | undefined): string {
  const trimmed = name?.trim();
  return trimmed && trimmed.length > 0 ? trimmed[0]!.toUpperCase() : '·';
}

export function UserAvatar({ url, firstName, className, initialClassName, testId }: Props): JSX.Element {
  const wrapClass = className ? `${styles.wrap} ${className}` : styles.wrap;
  if (url) {
    return (
      <div className={wrapClass} data-testid={testId} aria-hidden="true">
        <img src={url} alt="" className={styles.img} loading="lazy" />
      </div>
    );
  }
  return (
    <div className={wrapClass} data-testid={testId} aria-hidden="true">
      <span className={initialClassName ?? styles.initial}>{initialOf(firstName)}</span>
    </div>
  );
}
